// eslint-disable-next-line max-classes-per-file
import { PositionDetail } from '@ftr/annotations-contracts'
import { Uuid } from '@ftr/contracts/type/shared'

export const INTERNAL_POSITIONS_ACTION_SCOPE = '[Internal Positions List]'

export type PositionInvolvement = PositionDetail['involvement']

export class InitialiseInternalPositionsListCommand {
  static readonly type = `${INTERNAL_POSITIONS_ACTION_SCOPE} Initialise Internal Positions List`
  constructor(
    readonly courtSystemId: Uuid,
    readonly involvement: PositionInvolvement,
  ) {}
}

export class OrderInternalPositionsCommand {
  static readonly type = `${INTERNAL_POSITIONS_ACTION_SCOPE} Reorder Internal Positions List`
  constructor(
    public courtSystemId: Uuid,
    public involvement: PositionInvolvement,
    public internalPositions: PositionDetail[],
  ) {}
}

export class FetchInternalPositionsCommand {
  static readonly type = `${INTERNAL_POSITIONS_ACTION_SCOPE} Fetch Internal Positions`
  constructor(
    readonly courtSystemId: string,
    readonly involvement: PositionInvolvement,
  ) {}
}

export class AddInternalPositionCommand {
  static readonly type = `${INTERNAL_POSITIONS_ACTION_SCOPE} Add Internal Position`
  constructor(
    readonly courtSystemId: string,
    readonly involvement: PositionInvolvement,
    readonly positionName: string,
  ) {}
}

export class UpdateInternalPositionCommand {
  static readonly type = `${INTERNAL_POSITIONS_ACTION_SCOPE} Update Internal Position`
  constructor(
    readonly courtSystemId: string,
    readonly involvement: PositionInvolvement,
    readonly position: Pick<PositionDetail, 'id' | 'name'>,
  ) {}
}

export class DeleteInternalPositionCommand {
  static readonly type = `${INTERNAL_POSITIONS_ACTION_SCOPE} Delete Internal Position`
  constructor(
    readonly courtSystemId: string,
    readonly involvement: PositionInvolvement,
    readonly positionId: Uuid,
  ) {}
}
